export default {
  "en": {
    "inspiration": {
      "actions": {
        "delete": "Remove",
        "deleteMultipleInspirations": "Delete...",
        "delete_cancel": "Undo delete",
        "goBackToInspirationLists": "Inspirations",
        "new": "Add photo"
      },
      "labels": {
        "noInspirations": "No inspirations yet",
        "upload_autoclose": "This window will automatically close if all pictures are uploaded."
      },
      "toasts": {
        "upload_success": "{count} inspiration uploaded successfully | {count} inspirations uploaded successfully"
      }
    }
  }
}